import { css } from 'styled-components';

export const limitWidth = css`
    width: 95%;
    maxWidth: 1275px;
    margin: 0 auto;
`;
